import React from "react";
import ReactEChart from "echarts-for-react";
import Spinner from "@components/atoms/spinner/spinner";
import styles from "./alarm-time-series-graph-wrapper.module.scss";
import { TimeSeriesLineNoAlarmData } from "../time-series-line-no-alarm-data/time-series-line-no-alarm-data";

interface AlarmTimeSeriesGraphWrapperPropTypes {
  graphOptionsObject: any | undefined | null;
}

const cssClassName = "alarm-time-series-graph-wrapper";

export const AlarmTimeSeriesGraphWrapper = ({
  graphOptionsObject,
}: AlarmTimeSeriesGraphWrapperPropTypes) => {
  const Echart = () => {
    return (
      <div className={styles[`${cssClassName}__graph-wrapper`]}>
        <ReactEChart
          style={{
            width: "100%",
            height: "100%",
          }}
          option={graphOptionsObject}
        />
      </div>
    );
  };

  const MySpinner = () => {
    return (
      <div className={styles[`${cssClassName}__spinner-wrapper`]}>
        <Spinner />
      </div>
    );
  };

  const getContent = (options: any | undefined | null): JSX.Element => {
    const contentMap: { [key: string]: JSX.Element } = {
      undefined: <MySpinner />,
      null: <TimeSeriesLineNoAlarmData />,
      default: <Echart />,
    };

    return contentMap[
      options === undefined
        ? "undefined"
        : options === null
        ? "null"
        : "default"
    ];
  };

  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__graph-spinner-container`]}>
        {getContent(graphOptionsObject)}
      </div>
    </div>
  );
};
